// Which batches of a matrix-family question are open. The drawn list and the exporters both ask
// here, so a report exports exactly the batches the reader sees open.

import { calcUncollapsedKeys } from '@aytm/app/stats/page/question-views/components/lib/uncollapsed-param'

// A question with a single batch has nothing to choose between, so that batch opens on its own --
// and a hidden batch is never closed, since there is no row left to reopen it from.
export const calcOpenKeys = ({ batches, uncollapsed }) => {
  const stored = calcUncollapsedKeys(uncollapsed)
  if (stored.length) return stored

  if (1 === batches.length) return [String(batches[0].position)]

  return batches.filter(batch => batch.hidden).map(batch => String(batch.position))
}

// The batches drawn open: a question whose batches do not close draws every one of them open.
export const calcShownKeys = ({ batches, uncollapsed, expandable }) =>
  expandable ? calcOpenKeys({ batches, uncollapsed }) : batches.map(batch => String(batch.position))
